//  Images Import
import NationalFoods from "../all images/National Foods/National Masalay.jpg";
import OlpersMilk from "../all images/FrieslandCampina Engro Pakistan Limited/Olper's.jpg";
import OyehoyeSnacks from "../all images/Else Pics/OyehoyeSnacks.jpg";
import PeekFreansSooper from "../all images/EBM Peek Freans/Sooper.jpg";
import RooAfza from "../all images/Hamdard Pakistan/Rooh Afza.jpg";
import DaldaCookingOil from "../all images/Dalda Food Limited/Dalda Cooking Oil.jpg";
import TapalDanedar from "../all images/Tapal Tea/Tapal Danedar.jpg";
import GourmetCola from "../all images/Gourmet Foods/Gourmet Cola.jpg";

const PopularProuctsInfo = [
    { name: "Tapal Danedar", categery: "Grocery", img_src: TapalDanedar, },
    { name: "Sooper Peek Freans", categery: "Grocery", img_src: PeekFreansSooper, },
    { name: "Olpers Milk Pack", categery: "Packed Milk", img_src: OlpersMilk, },
    { name: "National Masalay", categery: "Grocery", img_src: NationalFoods, },
    { name: "Gourmet Cola", categery: "Foods & Beverage", img_src: GourmetCola, },
    { name: "Rooh Afza", categery: "Grocery", img_src: RooAfza, },
    { name: "Oye Hoye Snacks", categery: "Snacks & Beverage", img_src: OyehoyeSnacks, },
    { name: "Dalda Cooking Oil", categery: "Grocery", img_src: DaldaCookingOil, },
];

export default PopularProuctsInfo;